import React, { createContext, useContext } from "react";
import { useQuery } from '@tanstack/react-query';

import { getCategories } from "api/categories";
import { getTypes } from "api/types";

const Context = createContext({});

export function useCatalog() {
    return useContext(Context);
}

export function CatalogProvider(props) {

    const {data: categories, refetch: refetchCategories} = useQuery({
        queryKey: ["categories"],
        queryFn: () => getCategories(),
        refetchOnMount: false,
        refetchOnWindowFocus: false
    })

    const {data: types, refetch: refetchTypes} = useQuery({
        queryKey: ["types"],
        queryFn: () => getTypes(),
        refetchOnMount: false,
        refetchOnWindowFocus: false
    })

    const parkingTypesOptions = types?.filter(type => type.macro === 'parkings')?.map(type => {
        return {
            value: type._id,
            label: type.title || type.name
        }
    })

    const carTypesOptions = categories?.filter(category => category.macro === 'parkings')?.map(category => {
        return {
            value: category.slug,
            label: category.name || category.title
        }
    })

    return (
        <Context.Provider
            value={{
                categories,
                types,

                parkingTypesOptions,
                carTypesOptions,

                refetchCategories,
                refetchTypes,
            }}
        >
            {props.children}
        </Context.Provider>
    )
}